// Tagging a teammate in a backlog comment or a feedback internal note. The text keeps a mention as a Markdown
// link with a staff: address, [@Sam Martin](staff:<uuid>), so it survives edits and formatting. The console
// shows it as a tag, the API reads the ids from it (staff_mentions, migration 020), and plain text (the bell,
// anything a firm sees) keeps only "@Sam Martin".
const UUID = '[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}';
const mentionPattern = () => new RegExp(`\\[@([^\\]\\n]{1,120})\\]\\(staff:(${UUID})\\)`, 'gi');
/** The name as it can sit inside the link text: no brackets or line breaks. */
const cleanName = (name) => name.replace(/[[\]\n\r]/g, ' ').replace(/\s+/g, ' ').trim();
/** The name is cut to 120 characters, the most the pattern reads, so a long name never stays as raw markup. */
export const mentionMarkup = (p) => `[@${cleanName(p.name).slice(0, 120).trim()}](staff:${p.id.toLowerCase()})`;
/** Each tagged staff id once, in the order they first appear. */
export function mentionIds(text) {
    const ids = [...text.matchAll(mentionPattern())].map((m) => m[2].toLowerCase());
    return [...new Set(ids)];
}
/** "@Sam Martin" for every tag. */
export const mentionsToPlain = (text) => text.replace(mentionPattern(), '@$1');
const escape = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
/**
 * Turns "@Sam Martin" typed in a message box into a tag, for every teammate in `team`. Longer names win
 * ("@Sam Martinez" over "@Sam Martin"), a name must end at a word boundary, and existing tags stay as they are.
 */
export function linkMentions(text, team) {
    const byName = new Map();
    for (const p of team) {
        const name = cleanName(p.name);
        if (name && !byName.has(name.toLowerCase()))
            byName.set(name.toLowerCase(), p);
    }
    if (!byName.size)
        return text;
    const names = [...byName.keys()].sort((a, b) => b.length - a.length).map(escape);
    const typed = new RegExp(`(^|[^\\w\\[])@(${names.join('|')})(?![\\w])`, 'gi');
    // Leave existing tags alone: split them out, link only the text between.
    const tags = mentionPattern();
    let out = '';
    let last = 0;
    const link = (part) => part.replace(typed, (_m, before, name) => before + mentionMarkup(byName.get(name.toLowerCase())));
    for (const m of text.matchAll(tags)) {
        out += link(text.slice(last, m.index)) + m[0];
        last = m.index + m[0].length;
    }
    return out + link(text.slice(last));
}
//# sourceMappingURL=mentions.js.map